/* eslint-disable consistent-return */
import React from 'react';
import confetti from 'canvas-confetti';
import Silhouette from '@assets/icons/silhouette.svg';
import { ProfileAvatar } from '@shared/components';
import { getToken, decodeToken } from './token';

export * from './date';
export { default as responseFormatter } from './response-formatter';
export { rcApiResponseFormatter } from './response-formatter';
export * from './token';
export * from './query-string-builder';
export * from './file';
export { default as validate } from './validator';
export { default as isAuthorized, hasFeatureAccess } from './authorizer';
export { default as exportBase64ToFile } from './exportToFile';
export * from './jwks';

export const getRCRedirectUri = () =>
  `${process.env.REACT_APP_RC_AUTHORIZE_URL}&client_id=${process.env.REACT_APP_RC_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}&state=reassigner`;

const DIALOG_STATE = 'dialog-state';

export const getEmailId = (id, team) => {
  if (!(id && team)) {
    return;
  }

  const customer = team.customersTeam.find(user => user.rcuser_uid === id);
  const ringCentralMember = team.ringCentralTeam.find(
    member => member.rcuser_uid === id
  );

  if (customer) {
    return customer.email;
  }

  if (ringCentralMember) {
    return ringCentralMember.email;
  }
};

export const getUserName = (id, team, profiles) => {
  if (!(id && team)) {
    return;
  }
  const customer = team.customersTeam.find(user => user.rcuser_uid === id);

  const ringCentralMember = team.ringCentralTeam.find(
    member => member.rcuser_uid === id
  );

  if (customer) {
    return customer.name;
  }

  if (ringCentralMember) {
    return ringCentralMember.name;
  }

  if (profiles) {
    const user = profiles.find(profile => profile.id === id);
    return user ? `${user.firstName} ${user.lastName}` : null;
  }
};

export const isRingCentralMember = (id, team) => {
  if (!(id && team)) {
    return;
  }
  const customer = team.customersTeam.find(user => user.rcuser_uid === id);

  const ringCentralMember = team.ringCentralTeam.find(
    member => member.rcuser_uid === id
  );

  if (customer) {
    return false;
  }

  if (ringCentralMember) {
    return true;
  }
};

export const getProfileImage = (creatorId, profiles) => {
  if (!profiles || profiles.length === 0) {
    return Silhouette;
  }
  const userProfile = profiles.find(profile => profile.id === creatorId);
  if (userProfile) {
    return userProfile.avatar ? userProfile.avatar : Silhouette;
  }
  return Silhouette;
};

export const getProfileAvatar = (user, profiles) => {
  let userImage = Silhouette;
  const userProfile =
    profiles.find(({ id }) => {
      let comparisonId = null;
      // id === (user.creatorId || user.rcuser_uid)) ||
      // user
      if (user.creatorId) {
        if (user.type === 'TextMessage') {
          comparisonId = user.creatorId;
        } else if (user.mentions.length > 0) {
          comparisonId = user.mentions[0].id;
        }
      } else {
        comparisonId = user.rcuser_uid;
      }
      return id === comparisonId;
    }) || user;

  if (userProfile && userProfile.mentions && userProfile.mentions.length > 0) {
    userProfile.name = userProfile.mentions[0].name;
  }
  if (userProfile && userProfile.avatar) {
    userImage = userProfile.avatar;
  } else if (userProfile && (userProfile.firstName || userProfile.name)) {
    return <ProfileAvatar userData={userProfile} />;
  }

  return <img alt='' src={userImage} className='user-pic' />;
};

// export const getAccountData = () => {
//   const accountDataString = sessionStorage.getItem('account');
//   try {
//     const parsedData = JSON.parse(accountDataString);
//     if (!(parsedData.brand && parsedData.tier)) {
//       return {
//         brand: '',
//         tier: '',
//       };
//     } else {
//       return parsedData;
//     }
//   } catch (exception) {
//     return {
//       brand: '',
//       tier: '',
//     };
//   }
// };

// export const setAccountData = accountData => {
//   sessionStorage.setItem('account', JSON.stringify(accountData));
// };
export const updateScrollPosition = (containerRef, selectRef) => {
  setTimeout(() => {
    if (
      selectRef &&
      selectRef.current &&
      containerRef &&
      containerRef.current
    ) {
      const dropdownBounding = selectRef.current.getBoundingClientRect();
      const modalBounding = containerRef.current.getBoundingClientRect();
      if (dropdownBounding.bottom > modalBounding.bottom) {
        containerRef.current.scrollBy({
          top: dropdownBounding.bottom - modalBounding.bottom,
          behavior: 'smooth',
        });
      }
    }
  }, 0);
};

export const getPageConfig = (pageKey, useSessionStorage) => {
  let pageConfig = {};
  if (!pageKey) {
    return pageConfig;
  }

  let pageConfigs = localStorage.getItem('page-config');
  if (useSessionStorage) {
    pageConfigs = sessionStorage.getItem('page-config');
  }

  if (pageConfigs) {
    try {
      pageConfigs = JSON.parse(pageConfigs);
      const tokenData = decodeToken(getToken());
      const userConfig = pageConfigs[tokenData.rcuser_uid];
      if (userConfig) {
        pageConfig = userConfig[pageKey];
      }

      return pageConfig;
    } catch (exception) {
      console.log('CONFIG ISSUE');
      return pageConfig;
    }
  }
};

export const setPageConfig = (pageKey, config, useSessionStorage = false) => {
  if (!pageKey || !config) {
    return;
  }

  let pageConfig = {};
  let pageConfigs = localStorage.getItem('page-config');
  if (useSessionStorage) {
    pageConfigs = sessionStorage.getItem('page-config');
  }

  const tokenData = decodeToken(getToken());
  if (pageConfigs) {
    try {
      pageConfigs = JSON.parse(pageConfigs);
      const userConfig = pageConfigs[tokenData.rcuser_uid];
      if (userConfig) {
        pageConfig = userConfig[pageKey];
      }
      pageConfig = {
        ...pageConfig,
        ...config,
      };

      const dataToSave = JSON.stringify({
        ...pageConfigs,
        [tokenData.rcuser_uid]: {
          ...userConfig,
          [pageKey]: pageConfig,
        },
      });

      if (useSessionStorage) {
        sessionStorage.setItem('page-config', dataToSave);
      } else {
        localStorage.setItem('page-config', dataToSave);
      }
    } catch (exception) {
      console.log('INVALID CONFIG');
      const dataToSave = JSON.stringify({
        pageKey: config,
      });

      if (useSessionStorage) {
        sessionStorage.setItem('page-config', dataToSave);
      } else {
        localStorage.setItem('page-config', dataToSave);
      }
    }
  } else {
    const dataToSave = JSON.stringify({
      [tokenData.rcuser_uid]: {
        [pageKey]: config,
      },
    });
    if (useSessionStorage) {
      sessionStorage.setItem('page-config', dataToSave);
    } else {
      localStorage.setItem('page-config', dataToSave);
    }
  }
};

export const updatePagination = (count, paginationState, callback) => {
  if (typeof count === 'undefined') return;
  if (
    paginationState.pageNumber !== 1 &&
    count <= paginationState.pageSize * (paginationState.pageNumber - 1)
  ) {
    callback(paginationState.pageNumber - 1);
  }
};

export function findLastIndex(list, callback) {
  if (!Array.isArray(list)) {
    return null;
  }

  const reversedIndex = list.reverse().findIndex(callback);
  return reversedIndex >= 0 ? list.length - 1 - reversedIndex : reversedIndex;
}

function compareObject(value1, value2) {
  let areValuesEqual = true;

  if (!(value1 && value2)) {
    return false;
  }

  if (Object.keys(value1).length !== Object.keys(value2).length) {
    return false;
  }

  Object.keys(value2).forEach(key2 => {
    if (areValuesEqual) {
      if (Object.prototype.hasOwnProperty.call(value1, key2)) {
        if (typeof value1[key2] === typeof value2[key2]) {
          if (typeof value1[key2] === 'object') {
            if (!compareObject(value1[key2], value2[key2])) {
              areValuesEqual = false;
            }
          } else {
            if (typeof value1[key2] === 'function') {
              if (
                JSON.stringify(value1[key2]) !== JSON.stringify(value2[key2])
              ) {
                areValuesEqual = false;
              }
            } else {
              if (value1[key2] !== value2[key2]) {
                areValuesEqual = false;
              }
            }
          }
        } else {
          areValuesEqual = false;
        }
      } else {
        areValuesEqual = false;
      }
    }
  });

  return areValuesEqual;
}

export function areEqual(value1, value2) {
  let areValuesEqual = true;
  if (
    typeof value1 === typeof value2 &&
    Array.isArray(value1) === Array.isArray(value2)
  ) {
    if (typeof value1 === 'object') {
      if (Array.isArray(value1)) {
        if (value1.length === value2.length) {
          value1.forEach(element1 => {
            if (typeof element1 === 'object') {
              const objectsInValue2 = value2.filter(
                element2 => typeof element2 === 'object'
              );
              if (objectsInValue2.length > 0) {
                const equalObject2 = objectsInValue2
                  .filter(
                    element =>
                      Object.keys(element1).length ===
                      Object.keys(element).length
                  )
                  .find(element2 => {
                    return compareObject(element1, element2);
                  });

                if (!equalObject2) {
                  areValuesEqual = false;
                }
              } else {
                areValuesEqual = false;
              }
            } else {
              if (typeof element1 === 'function') {
                const sameElement2 = value2.find(
                  element2 =>
                    JSON.stringify(element1) === JSON.stringify(element2)
                );

                if (!sameElement2) {
                  areValuesEqual = false;
                }
              } else {
                const sameElement2 = value2.find(
                  element2 => element2 === element1
                );
                if (!sameElement2) {
                  areValuesEqual = false;
                }
              }
            }
          });
        } else {
          areValuesEqual = false;
        }
      } else {
        if (!compareObject(value1, value2)) {
          areValuesEqual = false;
        }
      }
    } else {
      if (typeof value1 === 'function') {
        if (JSON.stringify(value1) !== JSON.stringify(value2)) {
          areValuesEqual = false;
        } else {
          if (value1 !== value2) {
            areValuesEqual = false;
          }
        }
      }
    }
  } else {
    areValuesEqual = false;
  }

  return areValuesEqual;
}

export const debounce = (fn, time) => {
  let timeout;

  return function() {
    const functionCall = () => fn.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

export const getRCAccountId = () => {
  return localStorage.getItem('rcAccountId') || '';
};

export const getShowDialogStatus = () =>
  localStorage.getItem(DIALOG_STATE) || '';

export const setShowDialogStatus = value => {
  localStorage.setItem(DIALOG_STATE, value);
};

export const removeShowDialogStatus = () => {
  localStorage.removeItem(DIALOG_STATE);
};

export const showConfetti = (
  duration = 1 * 1000,
  delay = 0.25 * 1000,
  zIndex = 1301
) => {
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex };

  const randomInRange = (min, max) => Math.random() * (max - min) + min;
  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) return clearInterval(interval);
    const particleCount = 50 * (timeLeft / duration);
    confetti(
      Object.assign({}, defaults, {
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      })
    );
    confetti(
      Object.assign({}, defaults, {
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      })
    );
  }, delay);
};
